import { render, staticRenderFns } from "./test_props.vue?vue&type=template&id=172a5e19&"
import script from "./test_props.vue?vue&type=script&lang=js&"
export * from "./test_props.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!E:\\vue_project\\odoo14_chaxin_qzkj_vue\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports